import { useFlag } from '@mentimeter/flags/confidence/client';

/**
 * Hook to determine if a user is in the A/B test group for the education plans routing.
 * In confidence this is including both free users with educational organization type from onboarding questions
 * and users with educational subscriptions.
 *
 * @returns {boolean} True if the user is in the test group, false otherwise
 */

export function useIsEducationalUser(): boolean {
  const { value: isEducationPlansRoutingEnabled } = useFlag(
    'is-education-plans-routing.enabled',
    false,
  );
  return isEducationPlansRoutingEnabled;
}
